module.exports = __webpack_public_path__ + "img/share_video_bg.cab66117.png";